import { render, staticRenderFns } from "./atom.swatchbackground.vue?vue&type=template&id=5a621daa&scoped=true"
import script from "./atom.swatchbackground.vue?vue&type=script&lang=ts"
export * from "./atom.swatchbackground.vue?vue&type=script&lang=ts"
import style0 from "./atom.swatchbackground.vue?vue&type=style&index=0&id=5a621daa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a621daa",
  null
  
)

export default component.exports